import { Button, Typography } from "@material-ui/core";
import { Refresh, Warning } from "@material-ui/icons";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme)=> ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    }
}))

function ListError(props){

    const classes = useStyles()

    return (
        <div className={classes.root}>
            <Warning color='error' fontSize='large' />
            <Typography>
                {props.message || "An error occurred!"}
            </Typography>
            <Button 
                startIcon={<Refresh />}
                color='primary'
                onClick={props.onRetry}
            > 
                {props.retryMessage || "Retry"} 
            </Button>
        </div>
    )
}

export default ListError